<ngx-intl-tel-input [cssClass]="'form-control ' + (_control.control.errors &&
                                        _control.control.touched ? 'is-invalid':'') + ' ' + cssClass"
    [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
    [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedKingdom" [maxLength]="15"
    [phoneValidation]="true" [separateDialCode]="false" [numberFormat]="PhoneNumberFormat.National" [(ngModel)]="value"
    [formControl]="_control.control"></ngx-intl-tel-input>

<div *ngIf="_control.control.errors &&_control.control.touched" class="invalid-feedback mb-1">
    <ng-container *ngIf="_control.control.hasError('required')">
        Please provide your phone number.
    </ng-container>
    <ng-container *ngIf="_control.control.hasError('validatePhoneNumber')">
        Please provide a valid phone number.
    </ng-container>
</div>